import { styled } from "@styles";

export const ImageWrapper = styled.img`
  width: 100%;
`;

export const PointWrapper = styled.p`
  font-size: 3rem;
  text-align: right;
  margin-top: 1rem;
`;

export const Title = styled.h2`
  margin-top: 4rem;
  text-align: center;
  font-weight: bold;
`;